import { IFacetedFilterDataItem, IReplayItem } from "../types";
import { TypeCheck } from "./type-check";


export class ReplayAction {
    public static GetItemsToReplay(paths: string[], item: IFacetedFilterDataItem, value?: any): IReplayItem[] {
        const result: IReplayItem[] = [...this.getItemsList(item, [...paths])];
        if (value) {
            const facetItem = result[result.length - 1];

            facetItem.value = value;

            if (!facetItem.value) {
                facetItem.settable = true;
            }
        }

        return result;
    }

    private static getItemsList(item: IFacetedFilterDataItem, paths: string[], result?: IReplayItem[]): IReplayItem[] {
        const currentResult = result && result.length ? [...result] : [];
        const nextPathToken = paths[0];
        const childMatch = this.findChild(item, paths);
        const child = childMatch.child;
        let val: any;
        if (TypeCheck.isHierarchyContainer(item.type))
            val = nextPathToken;
        else
            val = item.value ? item.value : nextPathToken;

        const replayItem: IReplayItem = {
            item: item,
            value: val,
            paths: [item.path],
            targetPath: child?.path,
            actionable: paths.length === childMatch.consumedTokens && this.replayItemActionable(child)
        };

        currentResult.push(replayItem);

        if (item.items) {
            if (child) {
                paths.splice(0, childMatch.consumedTokens);
                return this.getItemsList(child, paths, currentResult);
            } else {
                return currentResult;
            }
        } else {
            return currentResult;
        }
    }

    private static findChild(item: IFacetedFilterDataItem, paths: string[]): { child?: IFacetedFilterDataItem, consumedTokens: number } {
        const pathToken = paths[0];
        if (!item.items?.length || !pathToken)
            return { consumedTokens: 0 };

        const expectedPath = item.path ? `${item.path}|${pathToken}` : pathToken;

        const directChild = item.items.find(i => i.path === expectedPath)
            ?? item.items.find(i => (i.label ?? i.name) === pathToken);
        if (directChild)
            return { child: directChild, consumedTokens: 1 };

        for (let tokenCount = 2; tokenCount <= paths.length; tokenCount++) {
            const expectedNestedPath = item.path
                ? `${item.path}|${paths.slice(0, tokenCount).join('|')}`
                : paths.slice(0, tokenCount).join('|');
            const nestedChild = item.items.find(i => i.path === expectedNestedPath);

            if (nestedChild)
                return { child: nestedChild, consumedTokens: tokenCount };
        }

        return { consumedTokens: 0 };
    }

    private static replayItemActionable(selectedItem: IFacetedFilterDataItem | undefined): boolean {
        if (!selectedItem)
            return false;

        return TypeCheck.isContainer(selectedItem.type);
    }

    private static replayItemIsSettable(paths: string[], item: IFacetedFilterDataItem): boolean {
        return paths.length === 0 && TypeCheck.isFacet(item.type) && !!item.value;
    }
}
